import { clsx } from 'clsx';
import 'react';
import '../Button/ButtonBase.js';
import '../utils/defaultSxProp.js';
import { ButtonComponent } from '../Button/Button.js';
import '@primer/behaviors/utils';
import '@primer/behaviors';
import '../utils/invariant.js';
import '../utils/warning.js';
import '@oddbird/popover-polyfill/fn';
import '../KeybindingHint/KeybindingHint.js';
import '../_VisuallyHidden.js';
import '../Box/Box.js';
import '../utils/includeSystemProps.js';
import { jsx } from 'react/jsx-runtime';
import '../Tooltip/Tooltip.js';
import Link from '../Link/Link.js';
import classes from './Blankslate.module.css.js';

function Blankslate({
  border,
  children,
  narrow,
  spacious,
  className
}) {
  return /*#__PURE__*/jsx("div", {
    className: classes.Container,
    children: /*#__PURE__*/jsx("div", {
      className: clsx(classes.Blankslate, className),
      "data-border": border,
      "data-narrow": narrow,
      "data-spacious": spacious,
      children: children
    })
  });
}
Blankslate.displayName = "Blankslate";
function Visual({
  children
}) {
  return /*#__PURE__*/jsx("span", {
    className: clsx('Blankslate-Visual', classes.Visual),
    children: children
  });
}
Visual.displayName = "Visual";
function Heading({
  as: Component = 'h2',
  children
}) {
  return /*#__PURE__*/jsx(Component, {
    className: clsx('Blankslate-Heading', classes.Heading),
    children: children
  });
}
Heading.displayName = "Heading";
function Description({
  children
}) {
  return /*#__PURE__*/jsx("p", {
    className: clsx('Blankslate-Description', classes.Description),
    children: children
  });
}
Description.displayName = "Description";
function PrimaryAction({
  children,
  href,
  ...props
}) {
  return /*#__PURE__*/jsx("div", {
    className: clsx('Blankslate-Action', classes.Action),
    children: /*#__PURE__*/jsx(ButtonComponent, {
      ...props,
      as: href ? 'a' : 'button',
      href: href,
      variant: "primary",
      children: children
    })
  });
}
PrimaryAction.displayName = "PrimaryAction";
function SecondaryAction({
  children,
  href
}) {
  return /*#__PURE__*/jsx("div", {
    className: clsx('Blankslate-Action', classes.Action),
    children: /*#__PURE__*/jsx(Link, {
      href: href,
      children: children
    })
  });
}
SecondaryAction.displayName = "SecondaryAction";
var Blankslate$1 = Object.assign(Blankslate, {
  Visual,
  Heading,
  Description,
  PrimaryAction,
  SecondaryAction
});

export { Blankslate$1 as default };
